const PANDASCORE_CDN_BASE_URL = 'https://cdn.pandascore.co/images/';
const THUMB_PREFIX = 'thumb_';

function getThumbnailUrl(url: string): string {
  const isPandascoreCdnUrl = url.startsWith(PANDASCORE_CDN_BASE_URL);
  if (isPandascoreCdnUrl) {
    const parts = url.split('/');
    const filenameIndex = parts.length - 1;
    const filename = parts[filenameIndex];
    const thumbFilename = THUMB_PREFIX + filename;
    parts[filenameIndex] = thumbFilename;

    return parts.join('/');
  }
  return url;
}

export { getThumbnailUrl };
